<template>
    <div class="message-box dialog-mask">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t(title, i18nData) }}</h4>
                </div>
                <div class="modal-body">
                    <!-- TODO: v-html can lead to XSS attacks and should be avoided  -->
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <p v-html="$t(content, i18nData)"></p>

                    <!-- Checkbox for confirmation -->
                    <div v-if="requireCheckbox" class="checkbox-container">
                        <FormCheckbox
                            id="confirmation-checkbox"
                            v-model="isChecked"
                            name="confirmation"
                            :label-text="checkboxLabel || 'I confirm this action'"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <ModalMultiButtons
                        :loading="loading"
                        data-cy="buttons"
                        btn-primary-id="confirm"
                        :btn-primary-text="$t(confirmLabel)"
                        :btn-secondary-text="$t(cancelLabel)"
                        :disabled="requireCheckbox && !isChecked"
                        :primary-button-click="clickYes"
                        :secondary-button-click="clickNo"
                        :secondary-button-hide="!cancelLabel"
                    ></ModalMultiButtons>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ModalMultiButtons, FormCheckbox } from '@arena/toolkit';
import modalEscMixin from '@/mixins/modalEscMixin';

export default {
    components: {
        ModalMultiButtons,
        FormCheckbox,
    },
    mixins: [modalEscMixin],
    props: {
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
        confirmLabel: {
            type: String,
            default: 'Ok',
        },
        confirmResult: {
            type: Boolean,
            default: true,
        },
        confirmFunction: {
            type: Function,
            default: null,
        },
        cancelLabel: {
            type: String,
            default: 'cancel',
        },
        cancelResult: {
            type: Boolean,
            default: false,
        },
        cancelFunction: {
            type: Function,
            default: null,
        },
        i18nData: {
            type: Object,
            default: () => {},
        },
        requireCheckbox: {
            type: Boolean,
            default: false,
        },
        checkboxLabel: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            isChecked: false,
        };
    },
    computed: {
        confirmedResult: {
            get() {
                return this.confirmResult;
            },
            set(newResult) {
                return newResult;
            },
        },
    },
    created() {
        this.handleEscCallbackToMixin = this.clickNo;
    },
    methods: {
        async clickYes() {
            try {
                if (this.confirmFunction) {
                    this.loading = true;
                    this.confirmedResult = await this.confirmFunction();
                }
                this.$close(this.confirmedResult);
            } catch (error) {
                this.$error(error);
            }
        },
        async clickNo() {
            try {
                if (this.cancelFunction) {
                    this.cancelResult = await this.cancelFunction();
                }
                this.$close(this.cancelResult);
            } catch (error) {
                this.$close(this.cancelResult);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-container {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f5f5;
    border-radius: 4px;
    border: 1px solid #ddd;

    :deep(.input-check) {
        position: relative;
        top: 2px;
    }
}
</style>
